export default __webpack_public_path__ + "static/Entenda0065-de45770ad6567d93d80659d60629be07.jpg";